export enum FiresideSocketMessages {
  JOIN_REQ = 'fireside-join-req',
  JOIN_ACCEPT = 'fireside-join-accept',
  JOIN_DENY = 'fireside-join-deny',
}

export enum SqsSocketTypes {
  CHAT = 'chat',
  QUESTION = 'question',
  QUESTION_COMMENT = 'question_comment',
  QUESTION_LIKE = 'question_like',
  QUESTION_UNLIKE = 'question_unlike',
  ANNOUNCEMENT = 'announcement',
  SURVEY = 'survey',
}
